import { Pagination } from "react-bootstrap";

const ClientPagination = ({ currentPage, totalPages, paginate, filteredUsers, clientsPerPage, indexOfFirstClient, indexOfLastClient}) => {
  return (
    <>
      {filteredUsers.length > clientsPerPage && (
        <div className="d-flex justify-content-center mt-4">
          <Pagination>
            <Pagination.Prev
              onClick={() => paginate(currentPage > 1 ? currentPage - 1 : currentPage)}
              disabled={currentPage === 1}
            />

            {Array.from({ length: totalPages }, (_, i) => {
              if (
                i === 0 ||
                i === totalPages - 1 ||
                (i >= currentPage - 2 && i <= currentPage + 2)
              ) {
                return (
                  <Pagination.Item
                    key={i + 1}
                    active={i + 1 === currentPage}
                    onClick={() => paginate(i + 1)}
                  >
                    {i + 1}
                  </Pagination.Item>
                );
              }
              return null;
            })}

            <Pagination.Next
              onClick={() => paginate(currentPage < totalPages ? currentPage + 1 : currentPage)}
              disabled={currentPage === totalPages}
            />
          </Pagination>
        </div>
      )}

      <div className="mt-3 text-muted">
        Showing {indexOfFirstClient + 1} to {Math.min(indexOfLastClient, filteredUsers.length)} of {filteredUsers.length} clients
      </div>
    </>
  );
};

export default ClientPagination;